// extracted by mini-css-extract-plugin
export default {"Spinner":"UPSLabels_Spinner__6+x9u","NoLabels":"UPSLabels_NoLabels__BSUfr","Link":"UPSLabels_Link__TMG3M","Row":"UPSLabels_Row__7rj0O","Input":"UPSLabels_Input__PkcXw"};